module.exports = __webpack_public_path__ + "static/icon-edit-cells-984a12db4ac9df88b8b25815d309fee4.svg";